import { render, staticRenderFns } from "./UploadResources.vue?vue&type=template&id=be323ce4&scoped=true&"
import script from "./UploadResources.vue?vue&type=script&lang=js&"
export * from "./UploadResources.vue?vue&type=script&lang=js&"
import style0 from "./UploadResources.vue?vue&type=style&index=0&id=be323ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be323ce4",
  null
  
)

export default component.exports